<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    top="10vh"
    width="90%"
    :title="$l('INDEX.choose_select_sample') || '选择已有样品'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    v-el-dialog-drag
    append-to-body
  >
    <SetSample
      ref="chooseSampleInner"
      :type="type"
      :sampleSetCode="sampleSetCode"
    />
    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button v-if="type" type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import SetSample from './index.vue'

export default {
  components: { SetSample },
  props: {
    visible: { type: Boolean, default: false },
    confirmOnClose: { type: Boolean, default: false },
    type: { type: String, default: '' },
    sampleSetCode: { type: String, default: '' },
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseSampleInner.choiceData()
      if (!data) return

      this.$emit('confirm', data)
      if (this.confirmOnClose) this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
